import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { AboutMenuComponent } from '../../shared/about-menu/about-menu.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { ManagementProfile } from '../../shared/models/management.model';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';

@Component({
  selector: 'app-representative',
  standalone: true,
  imports: [CommonModule, RouterLink, MainMenuComponent, AboutMenuComponent, SubscribeComponent],
  templateUrl: '../templates/representative.component.html'
})
export class RepresentativeComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly profile = signal<ManagementProfile | null>(null);

  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngOnInit(): void {
    this.loadProfile();
  }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  private async loadProfile(): Promise<void> {
    try {
      const response = await fetch('https://jntuanotifications.blob.core.windows.net/websites/management-profiles.json');
      if (!response.ok) {
        throw new Error(`Failed to load management profiles: ${response.status}`);
      }

      const profiles = (await response.json()) as ManagementProfile[];
      const profile = profiles.find(p => p.id === 'representative');
      this.profile.set(profile || null);
    } catch (error) {
      console.error('Failed to load representative profile JSON', error);
      this.profile.set(null);
    }
  }
}


